import sbm from "./sbm";

import type { Config } from "./common";

export type Configs = Record<string, Config>;

const configs: Configs = { sbm };

export default configs;
